import React from 'react'
import './Main.css'
import Header from '../Header/Header'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import NumerosMain from '../../Components/Admin/NumerosMain/NumerosMain'
import RifasMain from '../../Components/Admin/RifasMain/RifasMain'
import CardsCantidad from '../../Components/Admin/CardsCantidad/CardsCantidad'
import InfoUserMain from '../../Components/Admin/InfoUserMain/InfoUserMain'
import Grafico2 from '../../Components/Admin/Graficos/Grafico2'
import Grafico1 from '../../Components/Admin/Graficos/Grafico1'
export default function Main() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='containerMain'>
                    <div className='deFLexMain'>
                        <CardsCantidad />
                        <RifasMain />
                    </div>
                    <div className='graficosFlex'>
                        <Grafico1 />
                        <Grafico2 />
                    </div>
                    <div className='deFLexMain'>
                        <NumerosMain />
                        <InfoUserMain />
                    </div>


                </div>
            </section>
        </div>
    )
}
